import React, { Component } from 'react'

import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import ItemMenu from './ItemMenu';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';


import ExitToApp from '@material-ui/icons/ExitToApp';

import { temPermissao } from '../../../../modules/permissoes/functions'
import { DialogConfirma } from 'scorpion-core'

export default class Menu extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    getItemMenuUsar(item, menus) {

        const { onClick, history: { location }, classes } = this.props
        let itemPuro = this.getItemPuro2(item)
        if (!itemPuro) {
            return null;
        }
        let subDe = item.subDe
        if (subDe) {

            let expanded = this.state[subDe];
            let update = {}

            if (expanded === undefined) {
                expanded = false
                update[subDe] = true

            } else {
                update[subDe] = !expanded
            }

            let expandAction = () => this.setState(update);

            let mmm = null
            let indexMMM = 0
            menus.forEach((m, index) => {
                if (m.key === subDe) {
                    //console.log("m", m);
                    mmm = m
                    indexMMM = index
                }

            })
            if (!mmm) {
                let filhos = [];
                filhos.push(itemPuro)
                mmm = < ItemMenu
                    key={subDe}
                    classes={classes}
                    expanded={expanded}
                    expandAction={expandAction}
                    nome={subDe}
                    icone={undefined}
                    ordem={item.ordemPai ? item.ordemPai : 200}
                    filhos={filhos}
                />

                menus.push(mmm)
            } else {


                let filhos = [];
                if (mmm.props.filhos) {
                    filhos = mmm.props.filhos
                }

                filhos.push(itemPuro)
                let newMmm = < ItemMenu
                    key={subDe}
                    filhos={filhos}
                    {...mmm.props}
                />
                menus[indexMMM] = newMmm;
            }

        } else {
            return itemPuro
        }
    }

    getItemPuro2(item) {


        // permissaoConfig
        const { onClick, history: { location }, classes } = this.props
        if (item.permissao) {
            if (temPermissao(item.permissao)) {
                return <ItemMenu
                    key={item.rota ? item.rota + item.ordem : item.nome}
                    classes={classes}
                    onClick={() => {
                        if (location.pathname !== item.rota) {
                            this.props.limpaAppBarValues();
                        }
                        if (onClick) {
                            onClick();
                        }
                    }}
                    {...item} />
            }

            return null
        } else {
            return <ItemMenu
                key={item.rota ? item.rota + item.ordem : item.nome}
                classes={classes}
                onClick={() => {
                    if (location.pathname !== item.rota) {
                        this.props.limpaAppBarValues();
                    }
                    if (onClick) {
                        onClick();
                    }
                }}
                {...item} />
        }
    }
    render() {
        const { itens, onClick, history: { location }, classes } = this.props
        let menus = [];
        itens.forEach(item => {
            let im = this.getItemMenuUsar(item, menus)
            if (im && im.props) {
                menus.push(im)
            }
        });

        menus.sort((a, b) => (a.props.ordem > b.props.ordem) ? 1 : ((b.props.ordem > a.props.ordem) ? -1 : 0))

        return (
            <div className={classes.content2} >
                <div className={classes.toolbar2} >
                    {/* <Typography variant="h6" color="inherit" noWrap style={{flexGrow: 1,}}>Scorpion</Typography> */}

                </div>
                <Divider />
                <List>
                    {menus.map(m => m)}
                    <ListItem button onClick={() => {this.dialogConfirma.show() }}>
                        <ListItemIcon>
                            <ExitToApp className={classes.menuItem} />
                        </ListItemIcon>
                        {/* <ListItemText className={classes.menuItem}  >Sair</ListItemText> */}
                        <ListItemText
                            disableTypography
                            primary={<Typography className={classes.menuItem}>Sair</Typography>}
                        />
                    </ListItem>
                </List>
                <DialogConfirma innerRef={node => this.dialogConfirma = node} titulo={"Sair"} mensagem={"Deseja mesmo sair?"} onConfirm={() => { this.props.limpaAppBarValues(); this.props.logOff() }} />
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/components/Menu/components/Menu.js